import React, { useState } from "react";
import ParagraphTag from "../../../reusebale/Paragraph";
import LabelTag from "../../../reusebale/label";
import ButtonTag from "../../../reusebale/button";
import BaseUrl from "../../../../constants/BaseUrl";
import Myloader from "../../../reusebale/MyLoader";
import { ShowError } from "../../../../utils/ToasFunction";
import PropertySuccessPopup from "../../../popup/propertySuccess";
import * as DataAction from "../../../../store/actions/data/DataAction";
import { useSelector, useDispatch } from "react-redux";

const OverView = ({ formField, onCloseCreate }) => {
  const [loading, setLoading] = useState(false);
  const [succesPopup, setSuccessPopup] = useState(false);
  const dispatch = useDispatch();
  const { loginSuccess } = useSelector((state) => state.auth);
  const CreateHandler = () => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({
      firstName: formField.firstName,
      lastName: formField.lastName,
      email: formField.email,
      password: formField.password,
      type: formField.type,
      shiftHours: Number(formField.shoftHour),
      shiftDays: formField.schedule,
      role: "supportStaff",
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/support/signUp`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          setLoading(false);
          setSuccessPopup(true);
        } else {
          setLoading(false);
          ShowError(result.message);
        }
      })
      .catch((error) => console.error(error));
  };

  function GetSelectedDays(schedule) {
    return schedule
      .filter((item) => item.isSelected) // Filter selected days
      .map((item) => item.day) // Extract the 'day' value
      .join(", "); // Combine into a single string
  }
  return (
    <div className="w-[70%] mx-auto h-full">
      <div className="text-center h-[15%] flex flex-col justify-center">
        <ParagraphTag
          content="Support staff"
          classes="text-darkColor font-popinsSemiBold text-base 2xl:text-lg"
        />
        <div>
          <ParagraphTag
            content="Add info"
            classes="text-[#686868] font-popinsRegular text-xs"
          />
        </div>
      </div>
      <form className="overflow-y-scroll h-[75%] panelScroll px-1 pt-6">
        <div className="w-[60%] mx-auto">
          <div className="flex justify-between">
            <div className="w-[49%]">
              <ParagraphTag
                content="First Name"
                classes="text-darkColor font-popinsSemiBold text-sm"
              />
              <ParagraphTag
                content={formField?.firstName}
                classes="text-darkColor/40 font-popinsMedium text-xs"
              />
            </div>
            <div className="w-[49%]">
              <ParagraphTag
                content="Last Name"
                classes="text-darkColor font-popinsSemiBold text-sm"
              />
              <ParagraphTag
                content={formField?.lastName}
                classes="text-darkColor/40 font-popinsMedium text-xs"
              />
            </div>
          </div>
          <div className="flex justify-between mt-4">
            <div className="w-[49%]">
              <ParagraphTag
                content="Email Address"
                classes="text-darkColor font-popinsSemiBold text-sm"
              />
              <ParagraphTag
                content={formField?.email}
                classes="text-darkColor/40 font-popinsMedium text-xs"
              />
            </div>
            <div className="w-[49%]">
              <ParagraphTag
                content="Type"
                classes="text-darkColor font-popinsSemiBold text-sm"
              />
              <ParagraphTag
                content={formField?.type}
                classes="text-darkColor/40 font-popinsMedium text-xs"
              />
            </div>
          </div>
          <div className="flex justify-between mt-4">
            <div className="w-[49%]">
              <ParagraphTag
                content="Shift hours"
                classes="text-darkColor font-popinsSemiBold text-sm"
              />
              <ParagraphTag
                content={`${formField?.shoftHour} hours`}
                classes="text-darkColor/40 font-popinsMedium text-xs"
              />
            </div>
            <div className="w-[49%]">
              <ParagraphTag
                content="Days in a week"
                classes="text-darkColor font-popinsSemiBold text-sm"
              />
              <ParagraphTag
                content={GetSelectedDays(formField?.schedule)}
                classes="text-darkColor/40 font-popinsMedium text-xs"
              />
            </div>
          </div>
        </div>
      </form>
      <div className="h-[10%] flex justify-center">
        <div className="w-[80%] mx-auto flex gap-4">
          <div className="w-[50%]">
            <ButtonTag
              onSubmit={(e) => {
                e.preventDefault();
                dispatch(DataAction.SupportStaffStepsChangeAction(2));
              }}
              name="Back"
              classes="text-base text-center bg-gray-500 text-white"
            />
          </div>
          <div className="w-[50%]">
            {loading ? (
              <div className="felx justify-center items-center">
                <Myloader />
              </div>
            ) : (
              <ButtonTag
                onSubmit={() => {
                  if (formField.firstName === "") {
                    ShowError("First name is required ");
                  } else if (formField.lastName === "") {
                    ShowError("Last name is required ");
                  } else if (formField.email === "") {
                    ShowError("Email is required ");
                  } else if (formField.password === "") {
                    ShowError("Password is required ");
                  } else if (formField.shoftHour === "") {
                    ShowError("Shift hours is required ");
                  } else if (GetSelectedDays(formField?.schedule) === "") {
                    ShowError("Shift days are required");
                  } else {
                    CreateHandler();
                  }
                }}
                name="Create"
                classes="text-base text-center bg-themeColor text-white"
              />
            )}
          </div>
        </div>

        {succesPopup && (
          <PropertySuccessPopup
            succMessage="Support staff created successfully"
            onClose={() => {
              dispatch(DataAction.SupportStaffStepsChangeAction(1));
              setSuccessPopup(false);
              onCloseCreate();
            }}
          />
        )}
      </div>
    </div>
  );
};

export default OverView;
